import { useEffect, useState } from "react"
import { NavLink, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"

import useWindowDimensions from '../../hooks/useWindowDimensions.js'
import { logoutSession } from "../../redux/thunks/user"
import { resetPage } from "../../redux/slices/containerMovies.js"
import { resetSeriesPage } from "../../redux/slices/containerSeries.js"


const Navbar = () => {

    const dispatch = useDispatch();
    const { width } = useWindowDimensions()
    const navigate = useNavigate()
    const [showMenu, setShowMenu] = useState(false)
    const stateLogin = useSelector(state => state.user.stateLogin)
    const role = useSelector(state => state.user.role)


    const handleLogoutSession = () => {
        const user = window.localStorage.getItem('user')
        if (user) {
            const { id, token } = JSON.parse(user)
            dispatch(logoutSession({ id, token }))
            navigate('/')
        }
    }

    useEffect(() => {
        if (window.localStorage.getItem('user') && !stateLogin) window.localStorage.removeItem('user')
    }, [stateLogin])

    return (
        <div className="fl-rw spc-btw navbar__div">
            <div className="navbar__div__left">
                <a href="/"><img className="navbar__img" alt="logo" src={process.env.REACT_APP_LOGO} /></a>
            </div>
            <div className="navbar__div__right">
                {
                    width > 600
                        ? <ul className={`fl-rw spc-btw navbar__div__ul`}>
                            <li onClick={() => dispatch(resetPage())}><NavLink to="/" >Peliculas</NavLink></li>
                            <li onClick={() => dispatch(resetSeriesPage())}><NavLink to="/series" >Series</NavLink></li>
                            {
                                role !== "ADMIN"
                                    ? undefined
                                    : <li><NavLink to="/dashboard">Dashboard</NavLink></li>
                            }
                            {
                                !stateLogin
                                    ? <>
                                        <li><NavLink to="/login" >Iniciar sesion</NavLink></li>
                                        <li><NavLink to="/signin">Registrarse</NavLink></li>
                                    </>
                                    : <li onClick={handleLogoutSession}><NavLink>Cerrar sesion</NavLink></li>
                            }
                        </ul>
                        : <ul><NavLink><li onClick={() => setShowMenu(!showMenu)}>Menu</li></NavLink></ul>
                }
                {
                    showMenu && width <= 600
                        ? <ul onClick={() => setShowMenu(false)} className={`fl-cl spc-arnd navbar__div__menu`}>
                            <li onClick={() => dispatch(resetPage())}><NavLink to="/" >Peliculas</NavLink></li>
                            <li onClick={() => dispatch(resetSeriesPage())}><NavLink to="/series" >Series</NavLink></li>
                            {
                                role !== "ADMIN"
                                    ? undefined
                                    : <li><NavLink to="/dashboard">Dashboard</NavLink></li>
                            }
                            {
                                !stateLogin
                                    ? <>
                                        <li><NavLink to="/login" >Iniciar sesion</NavLink></li>
                                        <li><NavLink to="/signin">Registrarse</NavLink></li>
                                    </>
                                    : <li onClick={handleLogoutSession}><NavLink>Cerrar sesion</NavLink></li>
                            }
                        </ul>
                        : undefined
                }
            </div>
        </div>
    )
}

export default Navbar